import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiHttpService } from './api.http.service';
import { AuthService } from './auth.service';
import { NotificationService } from './notification.service';
import { Observable, tap } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class FamilyInviationService {
  constructor(
    private httpClient: ApiHttpService,
    private router: Router,
    public auth: AuthService,
    public notify: NotificationService
  ) {}
  public invitationDetails: any;
  public FcInvitationDetails: any;
  public AcceptInvitationDetails: any;
  public executorInvitationDetails: any;
  getInvitationDetails(id: string) {
    this.httpClient
      .get(`/api/Family/Invite/${id}`)
      .subscribe(({ data, error }) => {
        if (error) this.router.navigateByUrl('');
        if (data) this.invitationDetails = data;
      });
  }

  getFCInvitationDetails(id: string): Observable<any> {
    return this.httpClient.get(`/api/FCProfessional/Invite/${id}`).pipe(
      tap(({ data, error }) => {
        if (data) this.FcInvitationDetails = data;
      })
    );
  }

  crypt = (salt, text) => {
    const textToChars = (text) => text.split('').map((c) => c.charCodeAt(0));
    const byteHex = (n) => ('0' + Number(n).toString(16)).slice(-2);
    const applySaltToChar = (code) =>
      textToChars(salt).reduce((a, b) => a ^ b, code);

    return text
      .split('')
      .map(textToChars)
      .map(applySaltToChar)
      .map(byteHex)
      .join('');
  };

  AcceptInvitation(inviteId: string, password: string = '') {
    this.httpClient
      .post(`/api/Executor/AcceptInvite`, { inviteId, password })
      .subscribe(({ data, error }) => {
        if (data) {
          if (!password) {
            this.auth.login('user', false, '/executor');
          } else {
            this.auth.signUp(
              data?.[0],
              data?.[1],
              this.crypt('76edb6e1-735f-4622-bdc1-3c8d85be21e1', password)
            );
          }
        }
      });
  }
  AcceptFCInvitation(id) {
    this.httpClient
      .post(`/api/FCProfessional/AcceptInvite`, { inviteId: id })
      .subscribe(({ data }) => {
        this.AcceptInvitationDetails = data;

        if (!data) {
          this.notify.showError('Something went wrong!');
        }
      });
  }

  DeclineInvitation(inviteId: string) {
    this.httpClient
      .post(`/api/Executor/DeclineInvite`, { inviteId })
      .subscribe(({ data, error }) => {
        if (data) {
          this.router.navigateByUrl('/');
        }
      });
  }

  GetExecutorExistsStatus(id: string) {
    this.httpClient
      .get(`/api/Executor/GetExecutorExistsStatus/${id}`)
      .subscribe(({ data, error }) => {
        if (!data.isPending) {
          this.notify.showInfo(
            'The Link is invalid. Please send new invite link'
          );
          this.router.navigateByUrl('');
        }
        if (error) this.router.navigateByUrl('');
        else this.executorInvitationDetails = data;
      });
  }
}
